import { CONTEXT_ANSWER, getAnswerContextFromAnswer } from 'scripts/lib/analytics/snowplow/contexts/answer_context';
import {
  CONTEXT_COMPOSITION,
  getCompositionContextFromComposition,
} from 'scripts/lib/analytics/snowplow/contexts/composition_context';
import { CONTEXT_SEARCH, getSearchContext } from 'scripts/lib/analytics/snowplow/contexts/search_context';
import {
  CONTEXT_SEARCH_RESULT,
  getSearchResultContexts,
} from 'scripts/lib/analytics/snowplow/contexts/search_result_context';

const snowplowTypes = {
  CONTEXT_ANSWER,
  CONTEXT_COMPOSITION,
  CONTEXT_SEARCH,
  CONTEXT_SEARCH_RESULT,

  CONTEXT_GLADLY: 'iglu:com.gladly/context_gladly/jsonschema/1-0-0',

  EVENT_ANSWER_USED: 'iglu:com.gladly.agent_desktop/event_answer_used/jsonschema/1-0-4',
  EVENT_ANSWER_SEARCHED: 'iglu:com.gladly.agent_desktop/event_answer_searched/jsonschema/1-0-0',
  EVENT_COMPONENT_CLICKED: 'iglu:com.gladly.agent_desktop/event_component_clicked/jsonschema/1-0-0',
};

export {
  getAnswerContextFromAnswer,
  getCompositionContextFromComposition,
  getSearchContext,
  getSearchResultContexts,
  snowplowTypes,
};



// WEBPACK FOOTER //
// ./src/scripts/lib/analytics/snowplow/index.js